

// import React, { useState } from "react";
// import { Box, IconButton, Tooltip, Typography } from "@mui/material";
// import { Visibility } from "@mui/icons-material";
// import AssignedOrdersDialog from "./AssignedOrdersDialog";

// const AssignedOrdersCell = ({ data }) => {
//   const [dialogOpen, setDialogOpen] = useState(false);

//   const hasOrders = data && data.length > 0;
//   const count = data.length || 0;

//   const handleViewOrders = () => {
//     if (hasOrders) {
//       setDialogOpen(true);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: 1,
//         height: "100%",
//         minHeight: "52px",
//       }}
//     >
//       {hasOrders && (
//         <>
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <Typography
//               variant="body2"
//               sx={{ fontSize: "13px", marginRight: "4px" }}
//             >
//               {`Assigned Invoice${data.length !== 1 ? "s" : ""}:`}
//             </Typography>
//             <Typography variant="body2" sx={{ fontSize: "13px" }}>
//               {count}
//             </Typography>
//           </Box>
//           <Tooltip title={`View Order${data.length !== 1 ? "s" : ""}`}>
//             <IconButton
//               size="small"
//               onClick={handleViewOrders}
//               sx={{
//                 color: "#1976d2",
//                 "&:hover": {
//                   backgroundColor: "rgba(25, 118, 210, 0.04)",
//                 },
//               }}
//             >
//               <Visibility fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         </>
//       )}

//       {dialogOpen && (
//         <AssignedOrdersDialog
//           open={dialogOpen}
//           onClose={() => setDialogOpen(false)}
//           orders={data}
//         />
//       )}
//     </Box>
//   );
// };

// export default AssignedOrdersCell;

// ***********************************************************************************************************************************


import React, { useState } from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AssignedOrdersDialog from "./AssignedOrdersDialog";
import DriversReportTracker from "../Report/DriversReport/DriversReportTracker/index";

const AssignedOrdersCell = ({
  data,
  count: countProp,
  driverId,
  driverName,
  currentInvoicesState,
  currentInvoicesStateColor,
  currentInvoiceDrops,
  currentInvoiceReferences,
  currentInvoiceLines,
  currentInvoicesDeliveryDate,
  hasActiveDelivery,
  onClearOrders,
  onRefreshData,
  allDrivers,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [openTrackDelivery, setOpenTrackDelivery] = useState(false);

  const count = countProp ?? data?.length ?? 0;
  const hasOrders = count > 0;

  const handleViewOrders = () => {
    if (hasOrders) {
      setDialogOpen(true);
    }
  };

  const onTrackDeliveryClick = () => {
    setOpenTrackDelivery(true);
  };

  const handleCloseTrackDelivery = () => {
    setOpenTrackDelivery(false);
  };

  const handleClearOrders = (id, name) => {
    if (onClearOrders) {
      onClearOrders(id, name);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        height: "100%",
        minHeight: "52px",
      }}
    >
      <Typography variant="body2" sx={{ fontSize: "13px" }}>
        {count}
      </Typography>
      <Tooltip title={hasOrders ? `View Invoice${count !== 1 ? "s" : ""}` : ""}>
        <span>
          <IconButton
            size="small"
            onClick={handleViewOrders}
            disabled={!hasOrders}
            sx={{
              color: "#1976d2",
              "&:hover": {
                backgroundColor: "rgba(25, 118, 210, 0.04)",
              },
            }}
          >
            <Visibility fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Track Active Delivery">
        <span>
          <IconButton
            size="small"
            onClick={onTrackDeliveryClick}
            disabled={!hasActiveDelivery}
            sx={{
              color: hasActiveDelivery ? "#388e3c" : "#919191ff",
              "&:hover": {
                backgroundColor: "rgba(56, 142, 60, 0.04)",
              },
            }}
          >
            <LocalShippingIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      {dialogOpen && (
        <AssignedOrdersDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          orders={data}
          driverId={driverId}
          driverName={driverName}
          currentInvoicesState={currentInvoicesState}
          currentInvoicesStateColor={currentInvoicesStateColor}
          currentInvoiceDrops={currentInvoiceDrops}
          currentInvoiceReferences={currentInvoiceReferences}
          currentInvoiceLines={currentInvoiceLines}
          currentInvoicesDeliveryDate={currentInvoicesDeliveryDate}
          onClearOrders={handleClearOrders}
          onRefreshData={onRefreshData}
          allDrivers={allDrivers}
        />
      )}

      <Dialog
        open={openTrackDelivery}
        onClose={handleCloseTrackDelivery}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
          Delivery Route Tracker
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <DriversReportTracker driverId={driverId} />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleCloseTrackDelivery}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AssignedOrdersCell;